<template>
  <div>
    <el-dialog
      v-if="resultShow"
      :visible.sync="resultShow"
      width="80%"
      custom-class="more-info-dialog"
      :title="$t('resultLogButton.result')"
      center
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="download-button">
        <el-button
          @click="downloadClick"
          icon="el-icon-download"
          circle
          type="text"
        ></el-button>
      </div>
      <div class="more-info__inner">
        <div v-if="!resultLog" class="mono-text">{{ getRTRetFile }}</div>
        <div
          v-for="(line, index) in resultLog"
          :key="index"
          class="mono-text"
          :style="{
            whiteSpace: setWhiteSpacePre ? 'pre' : 'normal',
            marginLeft: setWhiteSpacePre ? '-9px' : '0px',
          }"
        >
          {{ line }}
        </div>
        </div>
        <div class="bottom-buttons">
          <div>
            <el-checkbox v-model="setWhiteSpacePre">{{
              $t("navigation.commonTree.showScroll")
            }}</el-checkbox>
          </div>
      </div>
    </el-dialog>
    <!-- для показа результата в статусе и в runTask -->
    <el-button
      @click="resultClick"
      type="primary"
      :class="{ 'el-icon-view': iconButton }"
      :disabled="disabled"
      >{{ iconButton ? " " : $t("resultLogButton.result") }}</el-button
    >
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      resultShow: false,
      resultLog: null,
      setWhiteSpacePre: true,
    };
  },
  props: {
    disabled: Boolean,
    queueId: Number,
    iconButton: Boolean,
  },
  methods: {
    downloadClick() {
      this.$store
        .dispatch("getResultLog", {
          type: "blob",
          queueId: this.queueId,
          fileName: "result.log",
        })
        .then(() => {
          let href = window.URL.createObjectURL(this.getRTRetFile);
          //создается выпадающее окно со ссылкой на файл
          var link = document.createElement("a");
          link.setAttribute("href", href);
          link.setAttribute("download", "result.log");
          document.body.appendChild(link); // Required for FF

          link.click(); // This will download the data file named "my_data.csv"
        })
        .catch((err) => console.error(err));
    },
    resultClick() {
      this.$store
        .dispatch("getResultLog", {
          type: "text",
          queueId: this.queueId,
          fileName: "result.log",
        })
        .then(() => {
          this.resultLog = this.getRTRetFile.split("\n");
          this.resultShow = true;
        })
        .catch((err) => console.error(err));
    },
  },
  computed: {
    ...mapGetters(["getRTRetFile"]),
  },
};
</script>

<style scoped>
.download-button {
  position: fixed;
  margin-top: -65px;
}
</style>